module.exports = __webpack_public_path__ + "static/media/family-suite-img7.8a93c7fc.jpg";